import { supabase } from '../lib/supabase';

export interface TicketCategory {
  id: string;
  name: string;
  description?: string;
  is_active: boolean;
  organization_id?: string;
  created_at?: string;
}

const client = () => {
  if (!supabase) throw new Error('Supabase client is not configured.');
  return supabase;
};

export const categoriesApi = {
  async getCategories(organizationId?: string) {
    let query = client().from('ticket_categories').select('*').order('name');
    if (organizationId && organizationId !== 'ALL') query = query.eq('organization_id', organizationId);
    const { data, error } = await query;
    if (error) throw error;
    return (data || []) as TicketCategory[];
  },
  async getCategoryById(id: string) {
    const { data, error } = await client().from('ticket_categories').select('*').eq('id', id).single();
    if (error) throw error;
    return data as TicketCategory;
  },
  async createCategory(payload: Partial<TicketCategory>) {
    const { data, error } = await client().from('ticket_categories').insert(payload).select().single();
    if (error) throw error;
    return data as TicketCategory;
  },
  async updateCategory(id: string, updates: Partial<TicketCategory>) {
    const { data, error } = await client().from('ticket_categories').update(updates).eq('id', id).select().single();
    if (error) throw error;
    return data as TicketCategory;
  },
  async deleteCategory(id: string) {
    const { error } = await client().from('ticket_categories').delete().eq('id', id);
    if (error) throw error;
    return { success: true };
  }
};
